// Styles
import IframeContainer from "../IframeContainer.styles";
import PowerBIDashboard from "../../../components/Common/PowerBIDashboard";
import React from "react";

type Props = {};

export default function ChartsAndAnalysis({}: Props) {
    return (
        <IframeContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="ce960974-a7a7-4272-9cd1-df4e96aedd6e"
                    workspaceId="0ab7398c-fff1-4373-b543-e7d6d23657cd"
                ></PowerBIDashboard>
            </div>
        </IframeContainer>
    );
}
